import { render } from "./disclaimer.vue?vue&type=template&id=54d4f47e&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"

import "./disclaimer.vue?vue&type=style&index=0&id=54d4f47e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54d4f47e"

export default script